import { useLayoutEffect, useState } from 'react';
import { color } from 'asserts/styles/colors';
import styled from 'styled-components';

import UserInfo from './UserInfo';
import BizInfo from './BizInfo';
import { QueryKeys, restfetcher } from 'queryClient';
import { useQuery } from '@tanstack/react-query';

interface AccountInfoProps {
  userInfo: UserInfor;
  companyInfo: CompanyInfor;
}

const AccountInfo = ({ userInfo, companyInfo }: AccountInfoProps) => {
  const requestAuthInfo = useQuery({
    queryKey: [QueryKeys.MYPAGEINFO],
    queryFn: () =>
      restfetcher({
        method: 'POST',
        path: 'biz/mypage/search/authinfo',
        params: {
          companyidx: companyInfo.companyidx
        }
      }),
    enabled: companyInfo.companyidx !== 0
  });

  const [userInfoData, setUserInfoData] = useState<UserInfoTypes>();

  useLayoutEffect(() => {
    if (requestAuthInfo.data?.result === 'success') {
      const memberInfo = requestAuthInfo.data?.usrinfo;
      setUserInfoData(memberInfo);
    }
  }, [
    requestAuthInfo.data?.bizinfo,
    requestAuthInfo.data?.result,
    requestAuthInfo.data?.usrinfo,
    userInfoData
  ]);

  return (
    <Wrapper>
      <h2>엑스바디 통합회원 계정정보</h2>
      <UserInfo userInfoData={userInfoData} />
      <h2>엑스바디 비즈멤버십 가입정보</h2>
      {requestAuthInfo.data?.result === 'success' && (
        <BizInfo bizInfo={requestAuthInfo.data.bizinfo} authInfoApi={requestAuthInfo} />
      )}
    </Wrapper>
  );
};

export default AccountInfo;

const Wrapper = styled.div`
  color: ${color.black2};
  min-height: 50vh;
  h2 {
    font-size: 24px;
    font-weight: 700;
    line-height: 28px;
    margin-bottom: 24px;
  }

  h2:last-of-type {
    margin-top: 48px;
  }

  th {
    text-align: center !important;

    &:first-of-type {
      width: 360px;
    }
  }

  & table thead th {
    color: ${color.gray600} !important;
  }

  tr {
    td:first-of-type {
      background: ${color.gray100};
      text-align: center;
      color: ${color.gray600};
      font-size: 14px;
      line-height: 18px;
      vertical-align: middle;
    }
  }

  i {
    color: ${color.red};
  }
`;
